import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';

@autobind
class StatusOrganizacao extends React.Component {
  render() {
    return <Lookup clearable={false} labelKey="descricao" valueKey="id" url="/StatusOrganizacaoLookup" {...this.props} />;
  }
}

export default StatusOrganizacao;
